import LoadExternalLibrary from './toolkit/LoadExternalLibrary';
const DEFAULT_LOGO_URL =
  'https://s3-us-west-1.amazonaws.com/near-me-assets/nearme-logo.png';

const SELECTOR = '[data-checkout-payment-form]';
const REMOVE_BUTTON_SELECTOR = '[data-remove-card-url]';

class CheckoutPaymentForm {
  constructor() {
    this.form = document.querySelector(SELECTOR);
    if (!this.form) {
      return;
    }

    this.initialize();
    this.bindEvents();
    this.loadStripe().then(this.configure.bind(this));
  }

  initialize() {
    this.publishableKey = this.form.dataset.publicKey;
    this.removeButtons = $(this.form).find(REMOVE_BUTTON_SELECTOR);
    this.tokenField = this.form.querySelector('[data-cc-token]');
    this.addCardContainer = this.form.querySelector('[data-add-new-card]');

    this.stripeEmail = this.form.dataset.checkoutUserEmail;
    this.stripeTitle = this.form.dataset.checkoutTitle;
    this.stripeDescription = this.form.dataset.checkoutDescription;
    this.stripeIcon = this.form.dataset.checkoutIcon || DEFAULT_LOGO_URL;

    this.trigger = this.createTrigger();
    this.addCardContainer.appendChild(this.trigger);
  }

  createTrigger() {
    let trigger = document.createElement('button');
    trigger.setAttribute('type', 'button');
    trigger.classList.add('button-b', 'button-lg');
    trigger.innerHTML = 'Add New Credit Card and Pay';
    return trigger;
  }

  bindEvents() {
    this.removeButtons.on('click', this.removeCard);

    this.trigger.addEventListener('click', () => {
      this.process()
        .then(() => {
          this.trigger.setAttribute('disabled', 'disabled');
          this.trigger.innerHTML = 'Processing&hellip;';
          this.form.submit();
        })
        .catch(error => {
          alert(error);
          throw new Error(error);
        });
    });
  }

  removeCard() {
    if (
      confirm(
        'Are you sure? If you have unpaid reservations associated with this card their payment will fail.'
      )
    ) {
      $(this)
        .text('Processing...')
        .attr('disabled', 'disabled');

      $.ajax({
        url: $(this).data('remove-card-url'),
        data: {
          form_configuration_name: 'client_destroy_credit_card'
        },
        dataType: 'json'
      })
        .done(function(data) {
          if (data.id) {
            let cards_left = $('span[data-cc-id]:visible').length;

            $(`span[data-cc-id='${data.id}']`).hide('slow');

            if (cards_left <= 1) {
              $('input[type=submit][data-pay-cc-card]').hide();
            }
          }
        })
        .fail(function() {
          $(this).text('remove');
          alert('Unauthorised action, Unable to remove Credit Card');
        });
    }
  }

  loadStripe() {
    return LoadExternalLibrary({
      name: 'StripeCheckout',
      url: 'https://checkout.stripe.com/checkout.js'
    });
  }

  configure(StripeCheckout) {
    this.processPromise = new Promise((resolve, reject) => {
      this.handler = StripeCheckout.configure({
        key: this.publishableKey,
        image: this.stripeIcon,
        locale: 'auto',
        token: token => {
          if (token.error) {
            reject(token.error.message);
            return;
          }

          // Insert the token ID into the form so it gets submitted to the server:
          this.tokenField.value = token.id;
          resolve();
        }
      });
    });
  }

  process() {
    this.handler.open({
      name: this.stripeTitle,
      description: this.stripeDescription,
      zipCode: true,
      email: this.email
    });
    return this.processPromise;
  }
}

export default CheckoutPaymentForm;



// WEBPACK FOOTER //
// ./src/javascripts/CheckoutPaymentForm.js